import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LandingPageConfigService } from './landing-page-config.service';
import { LandingPageConfigDto } from './landing-page-config.model';

export const whitelabelConfigResolver: ResolveFn<LandingPageConfigDto | null> =
  (): Observable<LandingPageConfigDto | null> => {
    return inject(LandingPageConfigService).getWhitelabelConfig().pipe(
      catchError(() => of(null))
    );
  };
